import { MapPin, Instagram, ExternalLink } from "lucide-react";

const INSTAGRAM_URL =
    "https://www.instagram.com/fotograf.sgarcia?igsh=NWNic2h0dTZ1bWgw";
const INSTAGRAM_HANDLE = "fotograf.sgarcia";

const MAP_SRC =
    "https://maps.google.com/maps?q=Fotograf.sgarcia%2C+48910+Sestao%2C+Biscay&t=&z=15&ie=UTF8&iwloc=&output=embed";
const MAP_LINK =
    "https://www.google.com/maps/search/?api=1&query=Fotograf.sgarcia%2C+48910+Sestao%2C+Biscay";

export default function MapInstagram() {
    return (
        <>
            {/* ---------- Mapa ---------- */}
            <section
                id="ubicacion"
                data-testid="map-section"
                className="relative py-14 sm:py-20 bg-[#FAFAF8]"
            >
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="text-center max-w-3xl mx-auto reveal">
                        <span className="text-[10px] tracking-[0.4em] uppercase text-[#C4A882]">
                            Encuéntrame
                        </span>
                        <h2
                            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#1C1A18] mt-4 leading-[1.1]"
                            data-testid="map-title"
                        >
                            Dónde estoy
                        </h2>
                        <p className="mt-6 text-[#6b665f] font-light">
                            Sestao, Bizkaia · País Vasco. Disponible en toda
                            España para sesiones, sesiones exteriores y
                            reportajes.
                        </p>
                    </div>

                    <div className="mt-10 sm:mt-14 reveal reveal-delay-1">
                        <div className="relative w-full overflow-hidden rounded-3xl border border-[#e6e2db] shadow-xl bg-white">
                            <div className="aspect-[16/9] sm:aspect-[21/9] w-full">
                                <iframe
                                    title="Mapa Silvia García Fotografía — Sestao"
                                    src={MAP_SRC}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0, display: "block" }}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    allowFullScreen
                                    data-testid="google-map-iframe"
                                />
                            </div>
                            <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-[#1C1A18] text-[#FAFAF8] px-4 py-2 rounded-full text-[10px] tracking-[0.32em] uppercase shadow-lg">
                                <MapPin
                                    size={14}
                                    strokeWidth={1.4}
                                    className="text-[#C4A882]"
                                />
                                Sestao · Biscay
                            </div>
                        </div>

                        <div className="mt-6 flex justify-center">
                            <a
                                href={MAP_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="map-open-google-btn"
                                className="inline-flex items-center gap-2 px-6 py-3 btn-outline-ink text-[11px] uppercase"
                            >
                                <ExternalLink size={14} strokeWidth={1.4} />
                                Abrir en Google Maps
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Instagram ---------- */}
            <section
                id="instagram"
                data-testid="instagram-section"
                className="relative py-14 sm:py-20 bg-[#F3EFE7]"
            >
                <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
                    <div className="reveal">
                        <span className="text-[10px] tracking-[0.4em] uppercase text-[#C4A882] inline-flex items-center gap-2 justify-center">
                            <Instagram size={14} strokeWidth={1.4} /> Instagram
                        </span>
                        <h2
                            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#1C1A18] mt-4 leading-[1.1]"
                            data-testid="instagram-title"
                        >
                            Sígueme en{" "}
                            <span className="font-script text-5xl sm:text-6xl lg:text-7xl text-[#C4A882]">
                                @{INSTAGRAM_HANDLE}
                            </span>
                        </h2>
                        <p className="mt-6 text-[#6b665f] font-light">
                            Cada semana subo nuevos momentos y detrás de cámara.
                        </p>
                    </div>

                    <div className="mt-10 reveal reveal-delay-1">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="instagram-follow-btn"
                            className="inline-flex items-center gap-3 px-10 py-4 text-white text-[11px] uppercase tracking-[0.18em] rounded-full shadow-xl transition-transform duration-200 hover:scale-105 active:scale-95"
                            style={{
                                background:
                                    "linear-gradient(45deg, #F58529 0%, #DD2A7B 35%, #8134AF 60%, #515BD4 100%)",
                            }}
                        >
                            <Instagram size={18} strokeWidth={1.6} />
                            Seguir en Instagram
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}
